import { PermissionSetType, ProjectId, UserId } from 'api/models';
import { useMemberships } from 'hooks/use-memberships';
import { useUser } from 'hooks/use-user';
import { Membership, Memberships } from 'stores/memberships';

/**
 * if the current is logged in user
 * Check for the user permission in the redux
 * if no, then check its availability in the profile and update the store
 * if yes get it
 *
 * if not the loggedin user
 * then chek in the store and get
 */
export const useUserProjectPermissions = (
  projectId: number,
  userId?: number,
): Membership | undefined => {
  const {
    user: { userId: loggedInUserId },
    permissions: { permissionSet },
  } = useUser();
  let currentUserId = userId;

  if (!currentUserId) {
    currentUserId = loggedInUserId;
  }

  const [, memberships = Memberships.empty()] = useMemberships(
    ProjectId(projectId),
  );

  if (
    permissionSet.permissionSetType === PermissionSetType.AccountAdmin ||
    permissionSet.permissionSetType === PermissionSetType.SuperUser
  ) {
    return {
      memberType: permissionSet.permissionSetType as any,
    };
  }

  return Memberships.find(UserId(currentUserId))(memberships);
};
